import { isRecord } from './isRecord';
import { unwrapListPayload } from './unwrapListPayload';
import { type IOrderPayment } from '@/types/IOrder';

/**
 * Проверяет, что значение — платёж заказа.
 *
 * Форма ответа GET /admin/payments/{order_uuid} в Swagger не описана
 * (`responses: default`), поэтому проверяются поля, без которых блок «Оплата»
 * бессмыслен: идентификатор, сумма, платёжная система и дата создания.
 * Остальные поля компоненты читают как необязательные.
 *
 * @param value - элемент ответа
 * @returns true, если значение можно показать как платёж
 */
export const isOrderPayment = (value: unknown): value is IOrderPayment =>
  isRecord(value) &&
  typeof value.id === 'number' &&
  typeof value.amount === 'number' &&
  typeof value.provider === 'string' &&
  typeof value.created_at === 'string' &&
  (value.added_by === null ||
    value.added_by === undefined ||
    isRecord(value.added_by));

/**
 * Разбирает ответ GET /admin/payments/{order_uuid}.
 * Записи, не похожие на платёж, отбрасываются: конверт и форма элемента бэком
 * не подтверждены.
 *
 * @param payload - тело ответа
 * @returns платежи заказа
 */
export const parseOrderPayments = (payload: unknown): IOrderPayment[] =>
  unwrapListPayload(payload).items.filter(isOrderPayment);
